import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m21.7 20.72-5.52-5.58a8.051 8.051 0 0 0 1.85-5.13c0-4.41-3.6-8.01-8.02-8.01S2 5.6 2 10.01s3.6 8.02 8.01 8.02c1.93 0 3.71-.69 5.1-1.83l5.52 5.57c.15.15.34.23.54.23s.38-.08.52-.22c.3-.29.3-.77.01-1.06Zm-11.69-4.19c-3.59 0-6.51-2.93-6.51-6.52 0-3.59 2.92-6.51 6.51-6.51s6.52 2.92 6.52 6.51-2.92 6.52-6.52 6.52Z"/> <path d="M12.39 12.4c-.15.15-.34.22-.53.22s-.39-.07-.53-.22l-1.32-1.32-1.31 1.31c-.15.14-.34.22-.53.22s-.39-.08-.53-.22c-.29-.3-.3-.77 0-1.06l1.31-1.31-1.31-1.31a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.3 1.3 1.32-1.32c.3-.29.77-.29 1.06 0 .3.29.3.77.01 1.06l-1.32 1.33 1.32 1.32c.29.29.29.77 0 1.06Z"/>' }
  })
);